export default __webpack_public_path__ + "static/media/number_autoparts_logo.cb11dbdf.jpg";